import React from 'react';

import Buttons from './Buttons';
import { Props as ControlProps } from '../index';

const Controls = ({ showZoomControl }: Props) => {
  if (!showZoomControl) return null;
  return (
    <Buttons />
  );
};

interface Props extends Pick<ControlProps, 'showZoomControl'> {}

export default Controls;